import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const InviteNew: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 40, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="40" height="40" rx="20" fill="currentColor" />
      <path
        d="M20.0013 20.1422C22.8419 20.1422 25.1446 17.8396 25.1446 14.9993C25.1446 12.159 22.8419 9.85645 20.0013 9.85645C17.1607 9.85645 14.8579 12.159 14.8579 14.9993C14.8579 17.8396 17.1607 20.1422 20.0013 20.1422Z"
        fill="white"
      />
      <path
        d="M12.9288 29.143H20.8753C19.7463 28.2383 18.9988 26.9423 18.7808 25.5121C18.5629 24.082 18.8905 22.6222 19.6987 21.4223C18.0366 21.3397 16.4705 20.6189 15.3269 19.4102C14.0448 19.9513 12.9507 20.8582 12.1811 22.0175C11.4116 23.1769 11.0008 24.5373 11 25.9287V27.2144C11.0015 27.7255 11.2052 28.2151 11.5666 28.5765C11.928 28.9378 12.4177 29.1415 12.9288 29.143Z"
        fill="white"
      />
      <path
        d="M20.001 24.6436C20.001 25.5336 20.2649 26.4036 20.7594 27.1436C21.254 27.8836 21.9568 28.4604 22.7792 28.801C23.6015 29.1416 24.5064 29.2307 25.3794 29.0571C26.2524 28.8835 27.0543 28.4549 27.6837 27.8255C28.3131 27.1962 28.7417 26.3944 28.9154 25.5215C29.089 24.6485 28.9999 23.7437 28.6593 22.9215C28.3187 22.0992 27.7418 21.3964 27.0017 20.9019C26.2616 20.4075 25.3915 20.1436 24.5014 20.1436C23.3082 20.1449 22.1643 20.6195 21.3206 21.4631C20.4769 22.3067 20.0023 23.4505 20.001 24.6436ZM25.1443 23.3578V24.0007H25.7873C25.9578 24.0007 26.1213 24.0684 26.2419 24.189C26.3624 24.3095 26.4302 24.4731 26.4302 24.6436C26.4302 24.8141 26.3624 24.9776 26.2419 25.0981C26.1213 25.2187 25.9578 25.2864 25.7873 25.2864H25.1443V25.9293C25.1443 26.0998 25.0766 26.2633 24.956 26.3838C24.8355 26.5044 24.6719 26.5721 24.5014 26.5721C24.3309 26.5721 24.1674 26.5044 24.0468 26.3838C23.9262 26.2633 23.8585 26.0998 23.8585 25.9293V25.2864H23.2156C23.0451 25.2864 22.8815 25.2187 22.761 25.0981C22.6404 24.9776 22.5727 24.8141 22.5727 24.6436C22.5727 24.4731 22.6404 24.3095 22.761 24.189C22.8815 24.0684 23.0451 24.0007 23.2156 24.0007H23.8585V23.3578C23.8585 23.1873 23.9262 23.0238 24.0468 22.9033C24.1674 22.7827 24.3309 22.715 24.5014 22.715C24.6719 22.715 24.8355 22.7827 24.956 22.9033C25.0766 23.0238 25.1443 23.1873 25.1443 23.3578Z"
        fill="white"
      />
    </svg>
  )
})

InviteNew.displayName = 'InviteNew'
